import { BenefitDto } from '../../../models/dtos/benefit.dto';
import axios from '../../axios';

export default async function getPartnersRequest(): Promise<BenefitDto[]> {
  const response = await axios.get<BenefitDto[]>(
    `${process.env.REACT_APP_BASE_URL}/users/partner`
  );
  return response.data;
}
